import { useParams } from "react-router-dom-v5-compat";
import { useGetAvailabilityQueryParams } from "@tenant/hotels";

export const useAvailabilityPageRoute = () => {
  const { location, placeId } = useParams();

  const queryParams = useGetAvailabilityQueryParams();

  if (location == null) {
    throw new Error("location is missing");
  }

  return {
    location,
    placeId,
    ...queryParams,
  };
};
